module.exports = __webpack_public_path__ + "img/a6.7475a279.jpg";